import {useState} from 'react';
import {Button, Spin, Upload} from 'antd';
import {PictureOutlined, UploadOutlined} from '@ant-design/icons';
import {toast} from 'react-toastify';
import {UploadDocumentToBucket} from 'pages/campaigns/new/screens/legalDocument/uploadDocument';
import {ANNOUNCEMENT_BUCKET} from './constants';
import styles from './fullScreenPopup.module.scss';

/**
 * Form-friendly icon uploader (value/onChange) for announcements. Same UX as the
 * flow-builder IconEditor, but uploads to the shared announcement S3 bucket so
 * all announcement media lives in one place.
 */
export const AnnouncementIconUpload = ({value, onChange}) => {
  const [uploading, setUploading] = useState(false);

  const handleBeforeUpload = async file => {
    if (!file.type?.startsWith('image/')) {
      toast.error('Please upload an image file (PNG, JPG, or SVG).');
      return Upload.LIST_IGNORE;
    }
    try {
      setUploading(true);
      const url = await UploadDocumentToBucket(
        file,
        () => {},
        ANNOUNCEMENT_BUCKET,
      );
      if (url) {
        onChange(url);
        toast.success('Icon uploaded');
      } else {
        toast.error('Icon upload failed');
      }
    } catch (error) {
      toast.error('Icon upload failed');
    } finally {
      setUploading(false);
    }
    return false; // prevent antd's default upload
  };

  return (
    <div className={styles.iconUpload}>
      <div className={styles.iconUploadPreview}>
        {value ? (
          <img src={value} alt="icon" />
        ) : uploading ? (
          <Spin size="small" />
        ) : (
          <PictureOutlined style={{color: '#94a3b8', fontSize: 22}} />
        )}
      </div>
      <div className={styles.iconUploadActions}>
        <Upload
          beforeUpload={handleBeforeUpload}
          maxCount={1}
          accept="image/*"
          disabled={uploading}
          showUploadList={false}>
          <Button icon={<UploadOutlined />} loading={uploading}>
            {value ? 'Replace icon' : 'Upload icon'}
          </Button>
        </Upload>
        {value ? (
          <Button
            type="link"
            danger
            size="small"
            style={{padding: 0, alignSelf: 'flex-start'}}
            onClick={() => onChange('')}>
            Remove
          </Button>
        ) : (
          <span className={styles.iconHint}>
            PNG / JPG / SVG · recommended 64×64
          </span>
        )}
      </div>
    </div>
  );
};
